<router-outlet (activate)="loadNavigationDocument($event)"></router-outlet>
